import { Stack } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';

import { getChapterProofsByOwnerOptions } from '@/module/Author/Chapter/Proof';

import { ProofCard } from '@feature/proof';
import { Id } from '@feature/utils';

interface ChapterOwnerProofListProps {
  chapterId: Id;
  userId: Id;
}

export function ChapterOwnerProofList({ chapterId, userId }: ChapterOwnerProofListProps) {
  const { data: proofs } = useSuspenseQuery(getChapterProofsByOwnerOptions(chapterId, userId));

  return (
    <Stack gap="xs">
      {proofs.map(proof => (
        <ProofCard
          key={proof.id}
          proof={proof}
          entity="chapter"
          canEdit={false}
          isPending={false}
        />
      ))}
    </Stack>
  );
}
